<template lang="pug">
.success-modal
  flex-modal(
    :title='moduleTitle',
    :btnText='btnText',
    :subBtnText='subBtnText',
    ref='modal',
    @cancel='cancel',
    @close='close',
    @confirm='confirm'
  )
    .modal-text.flex-mid(slot='body')
      template(v-if='type === MODAL_MODULE_TYPE.SUCCESS')
        .content.flex-mid
          .price
            .current {{ price }}
            .unit {{ unit }}
          .subtitle {{ title }}
          .btn
            span APP{{ isSwellCard ? "专享骑行卡" : "专享券" }}
        .bottom 可在“哈啰APP-我的钱包”查看
      template(v-else)
        .title.yellow 95%
          span 的用户都选择了膨胀
</template>

<script>
import FlexModal from '@/components/flex-modal';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { MODAL_MODULE_TYPE } from '../consts';
import { MARKET_OFFER_TYPE } from '../../../const';
import { tryCatch } from '../../../utils';

export default {
  components: {
    FlexModal,
  },
  data() {
    return {
      info: null,
      type: null,
      MODAL_MODULE_TYPE,
    };
  },
  computed: {
    price() {
      if (this.info) {
        const { swellPriceV2 } = this.info;
        return tryCatch(() => swellPriceV2[0].value, 0);
      }
      return 0;
    },
    unit() {
      return tryCatch(() => this.info.swellPriceV2[0].unit, '');
    },
    isSwellCard() {
      return this.info && this.info.swellOfferType === MARKET_OFFER_TYPE.CARD;
    },
    title() {
      if (this.info) {
        const {
          detail: { swellPrizeDetail },
        } = this.info;
        return swellPrizeDetail.propertyName || '';
      }
      return '';
    },
    doubleSuccess() {
      return this.type && this.type === MODAL_MODULE_TYPE.SUCCESS;
    },
    moduleTitle() {
      if (this.doubleSuccess) {
        return '膨胀成功';
      }
      return '你确定放弃膨胀吗';
    },
    btnText() {
      if (this.doubleSuccess) {
        return '去APP使用';
      }
      return '去膨胀';
    },
    subBtnText() {
      if (this.doubleSuccess) {
        return '稍后使用';
      }
      return '稍后膨胀';
    },
  },
  methods: {
    open(item) {
      this.info = item;
      this.type = item.type;
      this.$nextTick(() => this.$refs.modal.open());
    },
    close() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_Popup',
        categoryId: 'platform',
        businessInfo: {
          businessType: '2',
        },
      });
    },
    cancel() {
      this.$emit('cancel', { ...this.info, ...{ type: this.type } });
    },
    confirm() {
      this.$emit('confirm', { ...this.info, ...{ type: this.type } });
    },
  },
};
</script>

<style lang="less" scoped>
.fontSize(@fz, @fw, @lh, @c) {
  font-size: @fz;
  font-weight: @fw;
  color: @c;
  line-height: @lh;
}

.modal-text {
  flex-direction: column;

  .content {
    width: 1.32rem;
    height: 1.5rem;
    background-image: url('https://m.hellobike.com/resource/helloyun/15979/UuCzC6Gut-.png');
    background-size: 100% 100%;
    margin-bottom: 0.12rem;
    flex-direction: column;

    .price {
      display: flex;
      align-items: baseline;
      margin: 0.33rem 0 0.05rem;

      .current {
        margin-right: 0.03rem;
        .fontSize(0.4rem, 500, 0.35rem, #ff5526);
      }

      .unit {
        position: relative;
        bottom: 2px;
        .fontSize(0.15rem, 500, 0.13rem, #ff5526);
      }
    }

    .subtitle {
      max-width: 0.8rem;
      margin-bottom: 0.22rem;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: keep-all;
      .fontSize(0.11rem, 400, 0.13rem, #964500);
    }

    .btn {
      text-shadow: 0 0 0 #f75200;
      margin-bottom: 0.07rem;
      position: relative;
      top: 0.05rem;

      .fontSize(0.16rem, 500, 0.23rem, #fff);

      :first-of-type {
        font-weight: normal;
      }
    }
  }

  .bottom {
    .fontSize(0.12rem, 400, 0.17rem, #5a6066);
  }

  .title {
    line-height: 0.2rem;
    font-size: 0.14rem;

    > span {
      color: #5a6066;
    }
  }

  .yellow {
    color: #ff5526;
  }
}

.success-modal {
  /deep/ .modal-container {
    .modal-footer {
      .cancel {
        color: #5a6066 !important;
        background: #f0f3f5;
      }

      .border {
        border: none !important;
      }
    }
  }
}
</style>
